"use client";
import HeartIcon from "@/assets/svg/24/Heart";
import Link from "next/link";

import useWishlist from "@/lib/hooks/useWishlist";
import styles from "../header.module.css";

const ClientWishlistTrigger = () => {
  const { ids } = useWishlist();
  return (
    <Link
      href={"/onskeliste"}
      className={`${styles.icon} ${styles.favourites} ${
        ids.length > 0 && styles.active
      }`}
    >
      <HeartIcon />
    </Link>
  );
};

export default ClientWishlistTrigger;
